<template>
	<BaseCenteredMessage v-if="isRequested" hideActions>
		<template #title>Account deletion requested</template>
		<template #details>
			A confirmation email of your request has been sent to you. <br />
			Please click on the one-time link you'll find to confirm.
		</template>
	</BaseCenteredMessage>

	<BaseCenteredPage v-else>
		<div class="my-auto">
			<BaseIcon name="mono/warn-hexagon" class="mb-32 text-red-500 mx-auto block w-32 h-32" />
			<h1 class="mb-32 text-center text-strong-lg text-gray-100">Account deletion</h1>
			<main class="text-left text-gray-300" style="max-width: 320px">
				<p class="mb-32 text-red-500 text-strong-base">
					You are about to start the deletion of your account. This action is permanent and cannot be undone.
				</p>

				<ul class="list-disc list-outside ml-16">
					<li>Your account information will be permanently deleted.</li>
					<li>Workspaces where you are an admin and the only user will be deleted.</li>
					<li>All recordings stored in "Private folders" will be deleted.</li>
					<li>Workspaces with other members besides yourself will not be deleted.</li>
				</ul>

				<p class="my-32">
					By clicking the button below, you will receive a secure deletion link on your email address
					<span class="text-strong-base text-gray-100"> {{ $auth.user.value.email }} </span>
					to confirm your request.
				</p>
				<form ref="form" @submit.prevent="submitDeleteWorkspaceForm">
					<BaseButton
						class="button-red w-full mb-16 justify-center whitespace-nowrap"
						type="submit"
						:loading="isSendingLink"
					>
						Email me a link to delete my account
					</BaseButton>
				</form>
				<RouterLink class="mx-auto text-center block link-gray text-strong-base" to="/settings/account/profile">
					Cancel
				</RouterLink>
			</main>
		</div>
	</BaseCenteredPage>
</template>

<script>
import {useTitle} from 'shared/composables/useTitle'
export default {
	name: 'AccountDelete',
	setup() {
		return {
			title: useTitle(),
		}
	},
	data() {
		return {
			isSendingLink: false,
			isRequested: false,
		}
	},
	watch: {
		isRequested: {
			handler(isRequested) {
				this.title = isRequested ? 'Account deletion requested' : 'Delete account'
			},
		},
	},
	methods: {
		async submitDeleteWorkspaceForm() {
			if (this.isSendingLink) return
			this.isSendingLink = true

			try {
				await this.$api.post(`/users/delete-request`)
				this.isRequested = true
			} finally {
				this.isSendingLink = false
			}
		},
	},
}
</script>
